  import React, { Component } from "react";
  import PropTypes from "prop-types";
  import {
    tr,
    th,
    td,
    thead,
    Table,
    div,
    tbody,
    Button,
    DropdownButton,
    ButtonGroup,
    MenuItem,
    FormGroup,
    InputGroup,
    FormControl,
    Modal,
    ControlLabel,
    Alert,
    Tab,
    Tabs,
    Row,
    Col,
    ListGroup,
    ListGroupItem
  } from "react-bootstrap";
  import Dialog from "react-bootstrap-dialog";

  import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
  import { connect } from "react-redux";
  import { bindActionCreators, compose } from "redux";
  import { createBrowserHistory } from "history";
  import { withRouter, Link } from "react-router-dom";
  import { dealActions } from "../../../redux/actions/dealActions";
  import { categoriesActions } from "../../../redux/actions/categories";
  import { get_all_city } from "../../../redux/actions/countryCityActions";
  import ReactHtmlParser from "react-html-parser";

  import isEmpty from "lodash.isempty";
  import { alertsActions } from "../../../redux/actions/alertsActions";
  import {aclUtil} from "../../util"
  import {sortableContainer, sortableElement, arrayMove} from 'react-sortable-hoc';

  const history = createBrowserHistory();
  class OfferOrder extends Component {
    static contextTypes = {
      router: PropTypes.object
    }
    constructor(props) {
      super(props);
      this.state = {
        menuKey: 'UPDATE_OFFER_ORDER',
        dealList: [],
        cities: [],
        catList: [],
        dealSortIDs: [],
        alertMessage: "",
        msgType: "success",
        path: ["Home", "Manage Offers Order"],
        links: ["home", "offerOrder"],
        alertMessage: "",
        messageShow: false,
        loading: false,
        categoryId: "",
        cityId: "",
        cityIdError:"",
        categoryIdError:""
      };
      this.handleSearch = this.handleSearch.bind(this);
      this.handleSaveOrderDeal = this.handleSaveOrderDeal.bind(this);
      this.handleChangeExecution = this.handleChangeExecution.bind(this);
      this.cancelAction = this.cancelAction.bind(this);
      this.handleDismiss = this.handleDismiss.bind(this);
    }


    handleChangeExecution(e) {
      this.handleDismiss();
      const {actions: { clearAlerts }} = this.props;
        clearAlerts(); 
      this.setState({ [e.target.name]: e.target.value });
      if (`this.state.${e.target.name}Error` !== "") {
        this.setState({ [`${e.target.name}Error`]: "" });
      }
    }

    handleSearch() {
      this.handleDismiss();
      if(this.state.cityId != ""){
        this.setState({loading: true });
        const {actions: { getOrderDeals }} = this.props;
        getOrderDeals({catID: this.state.categoryId, cityID: this.state.cityId})
      }
      else if(this.state.cityId === ""){
        this.setState({cityIdError:'red'}) 
      }
    }

    handleSaveOrderDeal() {
      if(this.state.dealSortIDs.length> 0){
        this.setState({loading: true });
        const {actions: { saveOrderDeal }} = this.props;
        saveOrderDeal({catID: this.state.categoryId, cityID: this.state.cityId, dealIDs: this.state.dealSortIDs})
      }
    }

    handleDismiss() {
      this.setState({ messageShow: false });
    }

    cancelAction(){
      this.handleDismiss();
      const {actions: { clearAlerts }} = this.props;
        clearAlerts(); 
      this.setState({
          dealList: [],
          dealSortIDs: [],
          categoryId:"",
          cityId: ""
        });
    }

    componentDidMount() {
      const {actions: { getCategory }} = this.props;
      getCategory({offer_order: 0, page: 0});
      this.props.get_all_city({
        page: 0,
        orderBy: 'title',
        direction: 'asc',
        status: '1'
      });
    }


    componentWillReceiveProps(nextProps) {
      if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
        this.context.router.history.push("/restrictedAccess");
      }
      
      if(nextProps.dealList){
        this.setState({loading: false });
      }
      
      this.setState({loading: nextProps.sending });

      if (this.props.dealList !== nextProps.dealList && !isEmpty(nextProps.dealList) && nextProps.dealList.data && nextProps.dealList.data.length > 0) {
        this.setState({
          dealList: nextProps.dealList.data,
        });
        const {actions: { clearAlerts }} = this.props;
        clearAlerts();
      }
      else if(this.props.dealList !== nextProps.dealList && !isEmpty(nextProps.dealList) && nextProps.dealList.message && nextProps.dealList.data.length == 0){
        const {actions: { renderAlerts, clearAlerts }} = this.props;
        clearAlerts();
        renderAlerts("warning", nextProps.dealList.message)
      }

      if (this.props.catList !== nextProps.catList ) { 
        this.setState({
          catList: nextProps.catList.data.data,
        });
      }

      if (this.props.cities !== nextProps.cities && nextProps.cities.length > 0) {
        this.setState({
          cities: nextProps.cities,
        });
      }

      if (this.props.error !== nextProps.error) {
        this.setState({loading: true });
        if (nextProps.error) {
          this.props.clearAlert();
          this.props.renderAlert("warning", nextProps.error);
        }
      }

      if ( nextProps.message !== null && nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType,
          messageShow: true
        });
      }

      if(this.props.orderSaveData !== nextProps.orderSaveData && !isEmpty(nextProps.orderSaveData) && nextProps.orderSaveData.data){
        const {actions: { renderAlerts, clearAlerts }} = this.props;
        clearAlerts();
        renderAlerts("success", nextProps.orderSaveData.data)
      }
    }

    onSortEnd = ({oldIndex, newIndex}) => {
      let sortedDeals = arrayMove(this.state.dealList, oldIndex, newIndex);
      let dealSortIDs = sortedDeals.map(deal => deal.dealID);

      this.setState({
        dealList: sortedDeals,
        dealSortIDs: dealSortIDs
      });
    };

    render() {
      const {cities, catList, dealList, dealSortIDs} = this.state;
      let cityItems, categoryItems;
      if(cities.length > 0){
        cityItems = cities.map((cityObject, index) => (
          <option key={index} value={cityObject.cityID}>
            {cityObject.title}
          </option>
        ));
      }
      if(catList.length > 0){
        categoryItems = catList.map((categoryObject, index) => (
          <option key={index} value={categoryObject.catID}>
            {categoryObject.catName}
          </option>
        ));
      }

      const SortableItem = sortableElement(({value}) => <ListGroupItem>{ReactHtmlParser(value.mainDealText)} ({value.merchantName})</ListGroupItem>);

      const SortableContainer = sortableContainer(({children}) => {
        return <ListGroup>{children}</ListGroup>;
      });

      return (
        <div>
          <Dialog
            ref={el => {
              this.dialog = el;
            }}
          />
          <div className="col-lg-12 list-page">
            <div className="row">
              <div className="col-xs-12">
                <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
              </div>
            </div>
            <div className="panel">
              <header className="panel-heading">Offer's Order</header>
              <div className="panel-body">
                {this.state.messageShow &&
                  this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
                <div className="clearfix" />
                {(dealList.length == 0) && (
                  <Row>
                    <Col md={8} xs={12} mdOffset={2}>
                      <FormGroup controlId="formCatType">
                        <ControlLabel>
                          {" "}
                          <span style={{ color: "red" }}>*</span> City
                        </ControlLabel>

                        <FormControl
                          className="halfWidth"
                          componentClass="select"
                          name="cityId"
                          onChange={this.handleChangeExecution}
                          value={this.state.cityId}
                          style={{ borderColor: this.state.cityIdError }}
                        >
                          <option value="">Select City</option>
                          {cityItems}
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="formParentCategory">
                        <ControlLabel className="halfWidth">
                          Category
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          placeholder="Category"
                          name="categoryId"
                          value={this.state.categoryId}
                          onChange={this.handleChangeExecution}
                        >
                          <option value="">Select Category</option>
                          {categoryItems}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row> 
                )}
                {(dealList.length > 0) && (
                  <Row>
                    <Col md={12} xs={12}>
                      <SortableContainer onSortEnd={this.onSortEnd}>
                        {dealList.map((value, index) => (
                          <SortableItem key={`item-${index}`} index={index} value={value} />
                        ))}
                      </SortableContainer>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
            <Row className="BtnRow">
              <Col md={12} xs={12}>
                {(dealList.length == 0) && (
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="searchButton"
                    onClick={this.handleSearch}
                    disabled={this.state.loading}
                  >
                    Search
                  </Button>
                )}
                {(dealSortIDs.length > 0) && (
                    <Button
                      bsStyle="info"
                      type="submit"
                      id="searchButton"
                      onClick={this.handleSaveOrderDeal}
                      disabled={this.state.loading}
                    >
                      Save Order
                    </Button>
                )}
                {(dealList.length > 0) && (
                <Button bsStyle="default" onClick={this.cancelAction} >Cancel</Button>
                )}
              </Col>
            </Row>
          </div>
        </div>
      );
    }
  }

const mapStateToProps = state => ({
  dealList: state.dealReducer.dealList,
  catList: state.categoryReducer.cviews,
  orderSaveData: state.dealReducer.orderSaveData,
  sending: state.dealReducer.sending,
  cities: state.countryCityReducers.cities,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  orderSaveData: state.dealReducer.orderSaveData
});

const mapDispatchToProps = dispatch => {
  return {
    // getDealList: (formdata) => dispatch(getDealList(formdata)),
    get_all_city: (formdata) => dispatch(get_all_city(formdata)),
    actions: bindActionCreators(
      {
        ...dealActions,
        ...categoriesActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(OfferOrder));


// WEBPACK FOOTER //
// ./src/app/views/admin/deal/OfferOrder.js